import { Navigate } from 'react-router-dom';
import { getUserInfo } from '../utils/auth';
import Cookies from 'js-cookie';


const ProtectedRoute = ({ children, adminOnly = false }) => {
  const info = getUserInfo();
  const token = Cookies.get('Auth_Token');

  // If no token or user info, redirect to login
  if (!token || !info?.user?.role) return <Navigate to="/login" replace />;

  // If route is admin-only and user isn't admin
  if (adminOnly && info.user.role !== "Admin") {
    return <Navigate to="/learning-zone" replace />;
  }

// const ProtectedRoute = ({ children }) => {
//   const info = getUserInfo();

//   const token = Cookies.get('Auth_Token');

//   // If no token in cookies, redirect to login
//   if (!token) return <Navigate to="/login" />;
//   // If no user info or not admin, redirect to login
//   if (!info?.user?.role || info.user.role !== "Admin") return <Navigate to="/login" />;


  return children;
};

export default ProtectedRoute;
